import React from "react";
import { Box } from "@mui/material";
import { logoTokens } from "./tokens";

export default function LogoWordmark({ tone = "light", fontSize, sx, ...rest }) {
  const t = tone === "dark" ? "dark" : "light";
  const color = logoTokens.wordmark.color[t] ?? logoTokens.wordmark.color.light;
  const accent = logoTokens.wordmark.accent[t] ?? logoTokens.wordmark.accent.light;
  const name = logoTokens.brandName;
  const head = name.charAt(0);
  const tail = name.slice(1);

  return (
    <Box
      component="span"
      sx={{
        fontFamily: logoTokens.fontStack,
        fontWeight: logoTokens.wordmark.fontWeight,
        letterSpacing: logoTokens.wordmark.letterSpacing,
        fontSize,
        lineHeight: 1,
        color,
        whiteSpace: "nowrap",
        display: "inline-block",
        ...sx,
      }}
      {...rest}
    >
      <Box component="span" sx={{ color: accent }}>
        {head}
      </Box>
      {tail}
    </Box>
  );
}
